import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom"; // Import useParams to access URL parameters
import GmsTola from "../../../components/homeComponents/GmsTola";
import axios from "axios";
import GoToTop from "../../../Scroll/GoToTop";
import { Container } from "../../../components/Container";


const apiUrl = process.env.REACT_APP_BACKEND_URL;
 
const ReadMoreNotice = () => {
  const { id } = useParams(); // Get the notice ID from URL params
  const [notice, setNotice] = useState(null);

  useEffect(() => { 
    axios
      .get(`${apiUrl}/api/v1/getnotice/${id}`)
      .then((res) => {

        if (res.data && res.data.data) {
          setNotice(res.data.data);
        } else {
          console.error("Unexpected response format:", res.data);
        }
      })
      .catch((err) => {
        console.error("API Error:", err);
      });
  }, [id]); // Dependency array ensures useEffect runs when `id` changes

  const formatDateTime = (dateTime) => {
    const date = new Date(dateTime);
    return {
      date: date.toLocaleDateString(),
    };
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [notice]); 
  return (
    <Container>
      <GmsTola />
      <div className="px-[10px] my-[20px] font-poppins">
        <h1 className="border-b-[1px]">Notice</h1>
        {notice ? (
          <ul key={notice.id} className="list-disc my-[20px]">
            <p> Date: {formatDateTime(notice.date).date}</p>
            <img
              className="mx-auto my-[20px] md:w-auto md:h-auto h-[300px]"
              src={notice.imageUrl}
              alt="NoticeImage"
            />
            <p className="mx-auto">{notice.description}</p>
           
          </ul>
        ) : (
           <div className="border p-4 rounded-md animate-pulse bg-gray-100 my-5">
      <div className="h-6 bg-gray-300 rounded w-1/3 mb-4"></div> {/* Date */}
      <div className="h-64 bg-gray-300 rounded mb-4"></div> {/* Image */}
      <div className="h-4 bg-gray-300 rounded w-2/3"></div> {/* Description */}
    </div>
        )}
      </div>
      <GoToTop />
    </Container>
  );
};

export default ReadMoreNotice;
